export default {"src":"/_next/static/media/credits_circle.0bb5d0c3.svg","height":15,"width":15};